import React, { useState } from 'react';
import { Card, Col, Row, Form } from 'react-bootstrap';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import Flex from 'components/common/Flex';

const PrimaryInfo = () => {
  const [projectCategory, setProjectCategory] = useState(null);
  const [donationCurrency, setDonationCurrency] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [city, setCity] = useState(null);

  const projectCategoryOptions = [
    { value: '1', label: 'Zakat' },
    { value: '2', label: 'Water' },
    { value: '3', label: 'Food' },
    { value: '4', label: 'Cloth' }
  ];

  const cityOptions = [
    { value: '1', label: 'Mogadishu' },
    { value: '2', label: 'Nairobi' },
    { value: '3', label: 'Ruiru' },
    { value: '4', label: 'Karachi' }
  ];
  const donationCurrencyData = [
    { value: '1', label: 'USD' },
    { value: '2', label: 'PR' },
    { value: '3', label: 'EUR' }
  ];

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="fw-medium">Primary Information</Card.Title>
      </Card.Header>
      <Card.Body className="pt-0">
        <Row className="mb-3 g-3">
          <Form.Group as={Col} md="6" controlId="project_title">
            <Form.Label>
              Project Title <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control required type="text" placeholder="First name" />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>
              Project Category <span className="text-danger">*</span>
            </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={projectCategoryOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              value={projectCategory}
              onChange={value => setProjectCategory(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={12} controlId="ProjectDescription">
            <Form.Label>
              Project Description <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control as="textarea" rows={4} required />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md={12}>
            <Form.Label>
              Cities <span className="text-danger">*</span>
            </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={cityOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              className="we-raise"
              isMulti
              value={city}
              onChange={value => setCity(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md={6}>
            <Form.Label>
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <DatePicker
              selected={startDate}
              onChange={date => setStartDate(date)}
              className="form-control"
              placeholderText="DD/MM/YYYY"
              timeIntervals={5}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              fixedHeight
            />
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <DatePicker
              selected={endDate}
              onChange={date => setEndDate(date)}
              className="form-control"
              placeholderText="DD/MM/YYYY"
              timeIntervals={5}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              fixedHeight
            />
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="Number of Beneficiaries">
            <Form.Label>
              Number of Beneficiaries <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Number of Beneficiaries"
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>
              Currency <span className="text-danger">*</span>
            </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={donationCurrencyData}
              placeholder="Select"
              classNamePrefix="react-select"
              value={donationCurrency}
              onChange={value => setDonationCurrency(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="Total estimated Cost">
            <Form.Label>
              Total estimated Cost <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Total estimated Cost"
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            md="6"
            controlId="Average Cost per beneficiaries"
          >
            <Form.Label>Average Cost per beneficiaries</Form.Label>
            <Form.Control
              type="text"
              placeholder="Average Cost per beneficiaries"
            />
          </Form.Group>
        </Row>
        <Flex justifyContent={'between'}>
          <p className="mb-0 fw-medium fs-1">On going project ?</p>
          <Form.Check
            type="switch"
            id="checkedSwitch"
            label=""
            defaultChecked
          />
        </Flex>
      </Card.Body>
    </Card>
  );
};

export default PrimaryInfo;
